// Board Exam - Mental Health and Well-Being
// Complete file with 2 topics and questions

export const questions = {
  "1. Mental Health and Self-Care": [
    {
      id: 27100,
      question: "What skills must dental hygienists acquire to reduce professional burnout?",
      options: [
        "Technical skills only",
        "Stress management and self-care skills",
        "Administrative skills only",
        "Marketing skills"
      ],
      correct: "B"
    },
    {
      id: 27101,
      question: "How does learning self-care improve dental hygiene practice?",
      options: [
        "Increases income only",
        "Reduces working hours",
        "Improves overall quality of patient care",
        "Eliminates all workplace stress"
      ],
      correct: "C"
    },
    {
      id: 27102,
      question: "What percentage of respondents felt stressed about the COVID-19 pandemic?",
      options: [
        "Approximately one-quarter",
        "Approximately one-half",
        "Approximately one-third",
        "Approximately two-thirds"
      ],
      correct: "C"
    },
    {
      id: 27103,
      question: "Which generational group reported the most overall stress?",
      options: [
        "Baby Boomers",
        "Gen Xers",
        "Gen Z",
        "Millennials"
      ],
      correct: "D"
    },
    {
      id: 27104,
      question: "How many people worldwide live with a mental health problem?",
      options: [
        "One out of every four",
        "One out of every eight",
        "One out of every twelve",
        "One out of every sixteen"
      ],
      correct: "B"
    },
    {
      id: 27105,
      question: "What percentage of Canadians experience mental health problems yearly?",
      options: [
        "One in three",
        "One in five",
        "One in seven",
        "One in ten"
      ],
      correct: "B"
    },
    {
      id: 27106,
      question: "What percentage increase in sadness/hopelessness occurred since 2009?",
      options: [
        "20% increase",
        "30% increase",
        "40% increase",
        "50% increase"
      ],
      correct: "C"
    },
    {
      id: 27107,
      question: "What percentage of US adults reported mental health illness in 2019?",
      options: [
        "Approximately 10%",
        "Approximately 15%",
        "Approximately 20%",
        "Approximately 25%"
      ],
      correct: "C"
    },
    {
      id: 27108,
      question: "What is stress defined as?",
      options: [
        "Only physical discomfort",
        "Only emotional upset",
        "Physiological and psychological response to elements",
        "Only workplace problems"
      ],
      correct: "C"
    },
    {
      id: 27109,
      question: "What is a stressor?",
      options: [
        "Only external environment",
        "Only internal thoughts",
        "Element being responded to (internal or external)",
        "Only physical pain"
      ],
      correct: "C"
    },
    {
      id: 27110,
      question: "How many adults experience dental anxiety?",
      options: [
        "One out of four",
        "One out of six",
        "One out of eight",
        "One out of ten"
      ],
      correct: "B"
    },
    {
      id: 27111,
      question: "What percentage globally experience extreme dental fear?",
      options: [
        "1% to 6%",
        "5% to 10%",
        "10% to 15%",
        "15% to 20%"
      ],
      correct: "A"
    },
    {
      id: 27112,
      question: "What activates during stress response?",
      options: [
        "Parasympathetic system only",
        "Fight or flight response",
        "Digestive system",
        "Reproductive system"
      ],
      correct: "B"
    },
    {
      id: 27113,
      question: "What is eustress?",
      options: [
        "Negative stress only",
        "Chronic stress",
        "Stress from positive life events",
        "Absence of stress"
      ],
      correct: "C"
    },
    {
      id: 27114,
      question: "What does the brain release during eustress?",
      options: [
        "Cortisol",
        "Adrenaline only",
        "Endorphins",
        "Insulin"
      ],
      correct: "C"
    },
    {
      id: 27115,
      question: "What is distress?",
      options: [
        "Beneficial stress",
        "Short-term stress only",
        "Stress with deleterious impact on well-being",
        "Absence of stressors"
      ],
      correct: "C"
    },
    {
      id: 27116,
      question: "What hormones are released during distress?",
      options: [
        "Endorphins only",
        "Insulin only",
        "Cortisol and adrenaline",
        "Growth hormones"
      ],
      correct: "C"
    },
    {
      id: 27117,
      question: "What characterizes acute stress?",
      options: [
        "Long-term chronic condition",
        "Permanent state",
        "One-time occurrence or short-term nature",
        "Lasting years"
      ],
      correct: "C"
    },
    {
      id: 27118,
      question: "What is episodic acute stress?",
      options: [
        "Single stressor experience",
        "No stress at all",
        "Repeated acute stress in demanding jobs",
        "Long-term chronic stress"
      ],
      correct: "C"
    },
    {
      id: 27119,
      question: "What characterizes chronic stress?",
      options: [
        "One-time event",
        "Short-term experience",
        "Repeated stress that is long-term",
        "Beneficial stress"
      ],
      correct: "C"
    },
    {
      id: 27120,
      question: "What diseases are associated with chronic stress?",
      options: [
        "Only mental disorders",
        "Only infectious diseases",
        "Cardiovascular disease, insulin insensitivity, cancer",
        "Only respiratory diseases"
      ],
      correct: "C"
    },
    {
      id: 27121,
      question: "What percentage of US population experiences anxiety disorder lifetime?",
      options: [
        "Approximately 21%",
        "Approximately 26%",
        "Approximately 31%",
        "Approximately 36%"
      ],
      correct: "C"
    },
    {
      id: 27122,
      question: "What is the prevalence of major depressive disorder in US adults?",
      options: [
        "Approximately 4.4%",
        "Approximately 6.4%",
        "Approximately 8.4%",
        "Approximately 10.4%"
      ],
      correct: "C"
    },
    {
      id: 27123,
      question: "Which gender has higher prevalence of major depressive disorder?",
      options: [
        "Males",
        "Females",
        "Equal distribution",
        "Non-binary individuals"
      ],
      correct: "B"
    },
    {
      id: 27124,
      question: "Which age group has highest major depressive disorder prevalence?",
      options: [
        "Ages 12 to 17",
        "Ages 18 to 25",
        "Ages 26 to 40",
        "Ages 41 to 60"
      ],
      correct: "B"
    },
    {
      id: 27125,
      question: "What is the Vulnerability-Stress Model also known as?",
      options: [
        "Resilience Model",
        "Coping Model",
        "Diathesis-Stress Model",
        "Adaptation Model"
      ],
      correct: "C"
    },
    {
      id: 27126,
      question: "What does the Vulnerability-Stress Model explain?",
      options: [
        "Only genetic factors",
        "Only environmental factors",
        "Why individuals respond differently to same stressors",
        "Only childhood factors"
      ],
      correct: "C"
    },
    {
      id: 27127,
      question: "What characterizes professional burnout?",
      options: [
        "Increased energy and enthusiasm",
        "Improved work relationships",
        "Emotional/physical exhaustion and detachment",
        "Enhanced productivity"
      ],
      correct: "C"
    },
    {
      id: 27128,
      question: "Is burnout an individual mental health diagnosis?",
      options: [
        "Yes, it is a diagnosis",
        "Yes, it is a disorder",
        "No, it is emotional response to chronic stressors",
        "Yes, it is a syndrome"
      ],
      correct: "C"
    },
    {
      id: 27129,
      question: "What caused high burnout rates in dental professionals?",
      options: [
        "Increased salaries",
        "Better working conditions",
        "COVID-19 pandemic",
        "Reduced patient loads"
      ],
      correct: "C"
    },
    {
      id: 27130,
      question: "What professions experienced higher burnout during pandemic?",
      options: [
        "Only physicians",
        "Only nurses",
        "Dentists and dental hygienists",
        "Only dental assistants"
      ],
      correct: "C"
    },
    {
      id: 27131,
      question: "What did dental hygienists report considering?",
      options: [
        "Career advancement",
        "Additional education",
        "Leaving the profession",
        "Opening practices"
      ],
      correct: "C"
    },
    {
      id: 27132,
      question: "What contributes to professional burnout in dental hygiene?",
      options: [
        "Excessive vacation time",
        "Too few patients",
        "Time pressure, lack of autonomy, musculoskeletal disorders",
        "Overstaffing"
      ],
      correct: "C"
    },
    {
      id: 27133,
      question: "What affects ability to address patient anxiety?",
      options: [
        "Excessive free time",
        "Too many resources",
        "Appointment time constraints",
        "Abundant support"
      ],
      correct: "C"
    },
    {
      id: 27134,
      question: "What can inability to address anxiety lead to?",
      options: [
        "Better outcomes",
        "Improved satisfaction",
        "Feeling of personal failure, burnout, job dissatisfaction",
        "Career advancement"
      ],
      correct: "C"
    },
    {
      id: 27135,
      question: "What does mental health encompass?",
      options: [
        "Only absence of disease",
        "Only physical health",
        "Emotional, psychological, social well-being",
        "Only psychiatric conditions"
      ],
      correct: "C"
    },
    {
      id: 27136,
      question: "What does mental health affect?",
      options: [
        "Only thoughts",
        "Only feelings",
        "Thoughts, feelings, actions, relationships, physical health",
        "Only actions"
      ],
      correct: "C"
    },
    {
      id: 27137,
      question: "What are common mental health diagnoses?",
      options: [
        "Only schizophrenia",
        "Only bipolar disorder",
        "Anxiety, depression, post-traumatic stress disorder",
        "Only personality disorders"
      ],
      correct: "C"
    },
    {
      id: 27138,
      question: "What may psychiatric disorders be identified as?",
      options: [
        "Only temporary conditions",
        "Only mild concerns",
        "Serious mental illnesses",
        "Only genetic conditions"
      ],
      correct: "C"
    },
    {
      id: 27139,
      question: "Can most mental illnesses improve?",
      options: [
        "No, never improve",
        "Only with medication",
        "Yes, most can improve with treatment",
        "Only without treatment"
      ],
      correct: "C"
    },
    {
      id: 27140,
      question: "Who determines appropriate treatment?",
      options: [
        "Patient alone",
        "Family members",
        "Licensed mental health professional",
        "General public"
      ],
      correct: "C"
    },
    {
      id: 27141,
      question: "What are examples of licensed professionals?",
      options: [
        "Only dentists",
        "Only hygienists",
        "Psychologists, psychiatrists, counselors, social workers",
        "Only nurses"
      ],
      correct: "C"
    },
    {
      id: 27142,
      question: "What treatments may be recommended?",
      options: [
        "Only medication",
        "Only therapy",
        "Therapy, medication, mindfulness, support groups",
        "Only hospitalization"
      ],
      correct: "C"
    },
    {
      id: 27143,
      question: "What is important for dental hygienists to understand?",
      options: [
        "Mental health is unrelated to oral health",
        "Only physical factors matter",
        "Mental health and oral health relationship",
        "Only treatment planning"
      ],
      correct: "C"
    },
    {
      id: 27144,
      question: "How can mental health affect oral health?",
      options: [
        "No effect exists",
        "Only positive effects",
        "Neglect of daily oral hygiene, bruxism, eating disorders",
        "Only improves oral health"
      ],
      correct: "C"
    },
    {
      id: 27145,
      question: "What conditions can affect dental treatment?",
      options: [
        "No conditions affect treatment",
        "Only physical conditions",
        "Mental health conditions can affect dental treatment",
        "Only medication affects treatment"
      ],
      correct: "C"
    },
    {
      id: 27146,
      question: "What must dental professionals consider?",
      options: [
        "Only clinical procedures",
        "Only scheduling",
        "Physical and mental health holistically",
        "Only payment methods"
      ],
      correct: "C"
    },
    {
      id: 27147,
      question: "What approach provides comprehensive care?",
      options: [
        "Symptom-focused only",
        "Disease-focused only",
        "Holistic whole-person approach",
        "Procedure-focused only"
      ],
      correct: "C"
    },
    {
      id: 27148,
      question: "What is dental hygienist\'s role?",
      options: [
        "Diagnose mental illness",
        "Prescribe psychiatric medication",
        "Identify needs, provide resources, refer to professionals",
        "Provide therapy sessions"
      ],
      correct: "C"
    },
    {
      id: 27149,
      question: "What should dental hygienists observe?",
      options: [
        "Only teeth",
        "Only gums",
        "Behavioral changes, signs of distress, oral health changes",
        "Only calculus"
      ],
      correct: "C"
    },
    {
      id: 27150,
      question: "What is first step in providing resources?",
      options: [
        "Prescribe medication",
        "Diagnose condition",
        "Identify patient needs through assessment",
        "Schedule treatment"
      ],
      correct: "C"
    },
    {
      id: 27151,
      question: "What can dental hygienists use for assessment?",
      options: [
        "Only radiographs",
        "Only probing depths",
        "Human needs conceptual model",
        "Only visual examination"
      ],
      correct: "C"
    },
    {
      id: 27152,
      question: "What does human needs model identify?",
      options: [
        "Only cavities",
        "Only periodontal disease",
        "Fear, anxiety, stress, financial concerns",
        "Only enamel defects"
      ],
      correct: "C"
    },
    {
      id: 27153,
      question: "What should dental hygienists provide?",
      options: [
        "Medication samples",
        "Therapy sessions",
        "Educational materials, resources, referrals",
        "Psychiatric care"
      ],
      correct: "C"
    },
    {
      id: 27154,
      question: "What should be documented?",
      options: [
        "Nothing about mental health",
        "Only medications",
        "Behaviors, findings, recommendations, referrals",
        "Only chief complaints"
      ],
      correct: "C"
    },
    {
      id: 27155,
      question: "Where is information documented?",
      options: [
        "Public records",
        "Social media",
        "Confidential healthcare record",
        "Office bulletin board"
      ],
      correct: "C"
    },
    {
      id: 27156,
      question: "What must be maintained?",
      options: [
        "Public disclosure",
        "Open discussion",
        "Patient privacy and confidentiality",
        "Social sharing"
      ],
      correct: "C"
    },
    {
      id: 27157,
      question: "What is compassion?",
      options: [
        "Feeling sorry for someone",
        "Ignoring suffering",
        "Feeling of wanting to help relieve suffering",
        "Avoiding uncomfortable situations"
      ],
      correct: "C"
    },
    {
      id: 27158,
      question: "What is empathy?",
      options: [
        "Agreeing with everyone",
        "Avoiding others\' feelings",
        "Ability to relate to another\'s emotions",
        "Dismissing concerns"
      ],
      correct: "C"
    },
    {
      id: 27159,
      question: "Why are compassion and empathy important?",
      options: [
        "Only for appearance",
        "Only for reputation",
        "Create supportive environment for patients",
        "Only for documentation"
      ],
      correct: "C"
    },
    {
      id: 27160,
      question: "What does supportive environment encourage?",
      options: [
        "Patient avoidance",
        "Appointment cancellation",
        "Patients to share concerns and seek help",
        "Treatment refusal"
      ],
      correct: "C"
    },
    {
      id: 27161,
      question: "What should dental hygienists recognize?",
      options: [
        "Only their expertise",
        "Only their limitations",
        "When patients need referral to other professionals",
        "Only their schedule"
      ],
      correct: "C"
    },
    {
      id: 27162,
      question: "Who should be referred to?",
      options: [
        "Only dentists",
        "Only physicians",
        "Mental health professionals, primary care, specialists",
        "Only pharmacists"
      ],
      correct: "C"
    },
    {
      id: 27163,
      question: "What is Maslow\'s Hierarchy of Needs?",
      options: [
        "List of dental procedures",
        "Insurance payment schedule",
        "Model showing human motivation and needs",
        "Treatment planning guide"
      ],
      correct: "C"
    },
    {
      id: 27164,
      question: "What are basic physiological needs?",
      options: [
        "Self-actualization",
        "Esteem needs",
        "Food, water, shelter, sleep",
        "Social belonging"
      ],
      correct: "C"
    },
    {
      id: 27165,
      question: "What comes after physiological needs?",
      options: [
        "Self-actualization",
        "Love and belonging",
        "Safety and security needs",
        "Esteem needs"
      ],
      correct: "C"
    },
    {
      id: 27166,
      question: "What are examples of safety needs?",
      options: [
        "Friendship and intimacy",
        "Achievement and recognition",
        "Financial security, health, protection from harm",
        "Creative pursuits"
      ],
      correct: "C"
    },
    {
      id: 27167,
      question: "What represents love and belonging?",
      options: [
        "Money and possessions",
        "Professional achievements",
        "Friendship, family, intimacy, connections",
        "Physical health"
      ],
      correct: "C"
    },
    {
      id: 27168,
      question: "What are esteem needs?",
      options: [
        "Basic survival",
        "Physical safety",
        "Self-respect, recognition, achievement, confidence",
        "Food and water"
      ],
      correct: "C"
    },
    {
      id: 27169,
      question: "What is self-actualization?",
      options: [
        "Meeting basic needs",
        "Achieving safety",
        "Reaching full potential and personal growth",
        "Finding relationships"
      ],
      correct: "C"
    },
    {
      id: 27170,
      question: "What did Darby and Walsh develop?",
      options: [
        "Maslow\'s Hierarchy",
        "Stress model",
        "Human needs conceptual model for dental hygiene",
        "Burnout scale"
      ],
      correct: "C"
    },
    {
      id: 27171,
      question: "What does human needs model help with?",
      options: [
        "Only diagnosis",
        "Only treatment",
        "Patient assessment and care planning",
        "Only billing"
      ],
      correct: "C"
    },
    {
      id: 27172,
      question: "What are eight human needs in model?",
      options: [
        "Only physical needs",
        "Only emotional needs",
        "Freedom from stress, nutrition, wholesome facial image, etc.",
        "Only financial needs"
      ],
      correct: "C"
    },
    {
      id: 27173,
      question: "What is freedom from fear and stress?",
      options: [
        "Impossible to achieve",
        "Not a need",
        "Fundamental human need in dental care",
        "Only for children"
      ],
      correct: "C"
    },
    {
      id: 27174,
      question: "What is dental hygiene diagnosis?",
      options: [
        "Medical diagnosis",
        "Disease identification",
        "Unmet need that hygienist can address",
        "Prescription requirement"
      ],
      correct: "C"
    },
    {
      id: 27175,
      question: "How can hygienists address stress and fear?",
      options: [
        "Ignore them",
        "Rush through treatment",
        "Relaxation techniques, communication, environment",
        "Increase anxiety"
      ],
      correct: "C"
    },
    {
      id: 27176,
      question: "What techniques reduce anxiety?",
      options: [
        "Hurried appointments",
        "No explanations",
        "Deep breathing, progressive relaxation, guided imagery",
        "Complex terminology"
      ],
      correct: "C"
    },
    {
      id: 27177,
      question: "What is progressive muscle relaxation?",
      options: [
        "Muscle strengthening",
        "Physical therapy",
        "Tensing and releasing muscle groups",
        "Stretching only"
      ],
      correct: "C"
    },
    {
      id: 27178,
      question: "What is guided imagery?",
      options: [
        "Looking at pictures",
        "Reading magazines",
        "Visualizing calming peaceful scenes",
        "Watching videos"
      ],
      correct: "C"
    },
    {
      id: 27179,
      question: "What communication strategies help?",
      options: [
        "Medical jargon",
        "No explanations",
        "Clear explanations, active listening, encouraging questions",
        "Dismissive responses"
      ],
      correct: "C"
    },
    {
      id: 27180,
      question: "What environmental modifications help?",
      options: [
        "Bright lights",
        "Loud noises",
        "Comfortable temperature, calming music, pleasant scents",
        "Harsh environment"
      ],
      correct: "C"
    },
    {
      id: 27181,
      question: "What is tell-show-do technique?",
      options: [
        "For children only",
        "Not evidence-based",
        "Explaining, demonstrating, then performing procedure",
        "Outdated method"
      ],
      correct: "C"
    },
    {
      id: 27182,
      question: "What helps patients feel in control?",
      options: [
        "No input allowed",
        "No breaks",
        "Using signal for communication during treatment",
        "Ignoring concerns"
      ],
      correct: "C"
    },
    {
      id: 27183,
      question: "What is self-care?",
      options: [
        "Selfish behavior",
        "Unnecessary luxury",
        "Preserving or improving one\'s health and well-being",
        "Avoiding responsibility"
      ],
      correct: "C"
    },
    {
      id: 27184,
      question: "Why is self-care important?",
      options: [
        "Only for appearance",
        "Only for leisure",
        "Reduces burnout, maintains health, improves patient care",
        "Only for promotion"
      ],
      correct: "C"
    },
    {
      id: 27185,
      question: "What are categories of self-care?",
      options: [
        "Only physical",
        "Only mental",
        "Physical, mental/emotional, social, spiritual",
        "Only spiritual"
      ],
      correct: "C"
    },
    {
      id: 27186,
      question: "What is physical self-care?",
      options: [
        "Only exercise",
        "Only diet",
        "Exercise, nutrition, sleep, healthcare checkups",
        "Only sleep"
      ],
      correct: "C"
    },
    {
      id: 27187,
      question: "How does exercise affect stress?",
      options: [
        "Increases stress",
        "No effect",
        "Reduces stress levels",
        "Worsens mood"
      ],
      correct: "C"
    },
    {
      id: 27188,
      question: "What can stress contribute to behaviorally?",
      options: [
        "Better habits",
        "Improved routine",
        "Changes in eating and physical activity",
        "Enhanced self-care"
      ],
      correct: "C"
    },
    {
      id: 27189,
      question: "What can stress negatively affect over time?",
      options: [
        "Only mood",
        "Only energy",
        "Immune system, heart rate, blood pressure",
        "Only sleep"
      ],
      correct: "C"
    },
    {
      id: 27190,
      question: "What do individuals with greater vulnerabilities require?",
      options: [
        "More stressors to become distressed",
        "Same stress levels as everyone",
        "Fewer stress levels to become distressed",
        "No stress affects them"
      ],
      correct: "C"
    },
    {
      id: 27191,
      question: "What starts a career typically?",
      options: [
        "Reluctance and fear",
        "Indifference",
        "Enthusiasm and excitement",
        "Resignation"
      ],
      correct: "C"
    },
    {
      id: 27192,
      question: "What feeling correlates with professional burnout?",
      options: [
        "Enhanced connection",
        "Increased enthusiasm",
        "Detachment from work",
        "Better engagement"
      ],
      correct: "C"
    },
    {
      id: 27193,
      question: "What influences each other regarding burnout?",
      options: [
        "Only satisfaction",
        "Only burnout",
        "Job satisfaction, burnout, intention to leave",
        "Only intention"
      ],
      correct: "C"
    },
    {
      id: 27194,
      question: "What are dental hygienists susceptible to?",
      options: [
        "Enhanced flexibility",
        "Improved posture",
        "Musculoskeletal disorders",
        "Better ergonomics"
      ],
      correct: "C"
    },
    {
      id: 27195,
      question: "What causes musculoskeletal disorders in dental hygienists?",
      options: [
        "Excessive breaks",
        "Too much variety",
        "Repetitive movements, static positions, vibrating equipment",
        "Perfect ergonomics"
      ],
      correct: "C"
    },
    {
      id: 27196,
      question: "What can affect individual\'s mental health and job satisfaction?",
      options: [
        "Only positive factors",
        "Only pay increases",
        "Need for surgery, shortened career, recovery from work",
        "Only benefits"
      ],
      correct: "C"
    },
    {
      id: 27197,
      question: "What could affect individual all at once?",
      options: [
        "Only one stressor",
        "No stressors",
        "Multiple potential stressors of clinical practice",
        "Only positive events"
      ],
      correct: "C"
    },
    {
      id: 27198,
      question: "What heavily influences feeling valued?",
      options: [
        "Only title",
        "Only education",
        "Pay, appointment times, breaks",
        "Only location"
      ],
      correct: "C"
    },
    {
      id: 27199,
      question: "What do several studies reveal about autonomy?",
      options: [
        "No importance",
        "Minor factor",
        "Major influence of professional burnout",
        "Irrelevant factor"
      ],
      correct: "C"
    },
    {
      id: 27200,
      question: "When do individuals experience less burnout?",
      options: [
        "With no autonomy",
        "With unclear roles",
        "When perceiving autonomy or identifying roles",
        "With constant supervision"
      ],
      correct: "C"
    },
    {
      id: 27201,
      question: "What can imbalance between challenges and benefits increase?",
      options: [
        "Job satisfaction",
        "Performance",
        "Risk of burnout",
        "Enthusiasm"
      ],
      correct: "C"
    },
    {
      id: 27202,
      question: "What do providers report feeling when burnout occurs?",
      options: [
        "More enthusiastic",
        "More energized",
        "Cynical at work",
        "More motivated"
      ],
      correct: "C"
    },
    {
      id: 27203,
      question: "What may providers not perform to when burned out?",
      options: [
        "Expectations exceed ability",
        "Standards improve",
        "Best of their ability",
        "Enhanced level"
      ],
      correct: "C"
    },
    {
      id: 27204,
      question: "What stays elevated when stressor is repeated?",
      options: [
        "Energy levels",
        "Mood",
        "Inflammatory markers",
        "Performance"
      ],
      correct: "C"
    },
    {
      id: 27205,
      question: "What is associated with higher inflammatory responses?",
      options: [
        "Lower work stress",
        "No work stress",
        "Higher work stress",
        "Moderate work stress"
      ],
      correct: "C"
    },
    {
      id: 27206,
      question: "What can contribute to frequent leaves from work?",
      options: [
        "Excellent health",
        "High motivation",
        "Mental fatigue, impatience, frequent headaches",
        "Great satisfaction"
      ],
      correct: "C"
    },
    {
      id: 27207,
      question: "What may enduring chronic stress increase?",
      options: [
        "Career longevity",
        "Job satisfaction",
        "Likelihood of taking leave from work",
        "Performance quality"
      ],
      correct: "C"
    },
    {
      id: 27208,
      question: "What can dental hygienists do to mitigate risks?",
      options: [
        "Ignore symptoms",
        "Wait for crisis",
        "Address situation early and be proactive",
        "Deny problems"
      ],
      correct: "C"
    },
    {
      id: 27209,
      question: "What is one best way to protect against chronic stress?",
      options: [
        "Medication only",
        "Avoidance only",
        "Healthy lifestyle choices",
        "Isolation"
      ],
      correct: "C"
    },
    {
      id: 27210,
      question: "What has historically had a stigma?",
      options: [
        "Physical health",
        "Dental care",
        "Mental health",
        "Exercise"
      ],
      correct: "C"
    },
    {
      id: 27211,
      question: "What should people experiencing unmanageable stress do?",
      options: [
        "Ignore it",
        "Wait longer",
        "Seek professional help",
        "Handle alone"
      ],
      correct: "C"
    },
    {
      id: 27212,
      question: "What should individuals not wait for?",
      options: [
        "Perfect timing",
        "Complete breakdown",
        "Life feeling uncontrollable to seek help",
        "Others\' permission"
      ],
      correct: "C"
    },
    {
      id: 27213,
      question: "What can credentialed professionals identify?",
      options: [
        "Only symptoms",
        "Only medications",
        "Evidence-based treatment that would benefit you",
        "Only diagnosis"
      ],
      correct: "C"
    },
    {
      id: 27214,
      question: "What is important when selecting a professional?",
      options: [
        "Lowest cost only",
        "Closest location only",
        "Person is licensed with evidence-based practice",
        "Fastest appointment"
      ],
      correct: "C"
    },
    {
      id: 27215,
      question: "What should you avoid doing online?",
      options: [
        "Reading reputable sources",
        "Learning about stress",
        "Self-diagnosing based on information",
        "Finding resources"
      ],
      correct: "C"
    },
    {
      id: 27216,
      question: "What has this chapter highlighted?",
      options: [
        "Only clinical skills",
        "Only technical knowledge",
        "Importance of protecting mental health for patient care",
        "Only physical health"
      ],
      correct: "C"
    }
  ],
  "1. Mental Health and Self-Care (Case Study)": [
    {
      id: 27300,
      question: "CASE 1: Sarah is a 28-year-old dental hygienist who graduated 3 years ago. She reports difficulty falling asleep, waking frequently during the night with racing thoughts about work. She experiences tension headaches at least 3 times weekly and notices jaw clenching during the day. Sarah mentions feeling overwhelmed by her patient schedule and constantly worries about meeting treatment goals. She has been taking ibuprofen daily for muscle tension. What physiological response is Sarah most likely experiencing?",
      options: [
        "Her parasympathetic nervous system is activated, releasing acetylcholine to reduce muscle tension and promote relaxation",
        "Her sympathetic nervous system is activated, triggering the fight or flight response with elevated cortisol and adrenaline",
        "Her endocrine system is releasing endorphins to manage the positive stress associated with career advancement",
        "Her immune system is producing inflammatory markers as a protective response to acute workplace challenges"
      ],
      correct: "B"
    },
    {
      id: 27301,
      question: "CASE 2: Marcus is a 35-year-old patient presenting for a routine hygiene appointment. During the health history update, he mentions taking sertraline (an SSRI) for generalized anxiety disorder. He reports feeling \"on edge\" most days, has difficulty controlling worry, and experiences fatigue and concentration problems. His intraoral examination reveals moderate xerostomia, generalized mild gingivitis, and evidence of bruxism on posterior teeth. Which oral condition is MOST directly related to Marcus's SSRI medication?",
      options: [
        "The bruxism observed on posterior teeth, as SSRIs commonly cause involuntary jaw clenching and grinding",
        "The generalized mild gingivitis due to medication-induced gingival hyperplasia from long-term SSRI use",
        "The moderate xerostomia, as reduced salivary flow is a very common side effect of SSRI medications",
        "The patient's anxiety about dental treatment, which is often intensified by selective serotonin reuptake inhibitors"
      ],
      correct: "C"
    },
    {
      id: 27302,
      question: "CASE 3: Jennifer is a 42-year-old dental hygienist working in a busy FQHC. She sees 8-9 patients daily in 60-minute appointments with a 30-minute lunch break. Over the past 6 months, she reports decreased enthusiasm for work, feels emotionally detached from patients, and questions whether she made the right career choice. She experiences chronic neck and shoulder pain and feels exhausted even after weekends off. Jennifer states her work no longer aligns with her initial passion for patient education and disease prevention. What phenomenon is Jennifer MOST likely experiencing?",
      options: [
        "Acute stress response from temporary workplace conflicts that will resolve with brief vacation time away",
        "Professional burnout characterized by emotional exhaustion, detachment from work, and feelings of reduced accomplishment",
        "Eustress related to positive career advancement and increased professional responsibilities requiring better time management",
        "Major depressive disorder requiring immediate psychiatric intervention and extended medical leave from practice"
      ],
      correct: "B"
    },
    {
      id: 27303,
      question: "CASE 4: A 19-year-old college student presents for her first dental visit in 3 years. She appears nervous, with rapid speech and fidgeting hands. When asked about her delay in care, she mentions \"feeling panicked\" in dental offices, describing previous episodes of racing heart, feeling faint, and experiencing a choking sensation during dental procedures. She reports these symptoms occur specifically in dental settings and asks if treatment is possible despite her fears. According to the document, what percentage of adults globally experience dental anxiety similar to this patient's presentation?",
      options: [
        "Approximately 1-6% experience extreme dental fear, with one out of every six adults experiencing dental anxiety",
        "Roughly 15-20% of adults report moderate dental anxiety, while 5-8% have severe dental phobia",
        "About 25-30% of the adult population experiences some level of dental-related anxiety or fear",
        "Nearly 40-45% of adults avoid dental care due to anxiety, representing the majority of patients"
      ],
      correct: "A"
    },
    {
      id: 27304,
      question: "CASE 5: Brooklyn is a 35-year-old single mother and dental hygienist working Monday through Thursday, 7:30 AM to past 5 PM. She has two children (ages 10 and 13) and manages their soccer, taekwondo, and homework after work. She reports sleep disturbances, waking throughout the night, feeling a \"tightness in her stomach\" before work, and snapping at her children more frequently. Brooklyn mentions taking ibuprofen every morning and evening for tension headaches. She feels resentful toward coworkers and guilty about constant drive-thru dinners for her family. Which type of stress is Brooklyn experiencing based on the duration and nature of her stressors?",
      options: [
        "Acute stress from a one-time occurrence that will resolve once her children's activity season ends",
        "Eustress from positive life events including career success and children's extracurricular involvement and achievements",
        "Episodic acute stress from multiple demanding responsibilities occurring repeatedly over extended time periods",
        "Chronic stress from repeated exposure to long-term stressors affecting both work and personal life"
      ],
      correct: "D"
    },
    {
      id: 27305,
      question: "CASE 6: A dental hygienist notices a 16-year-old patient has lost significant weight since her last visit 6 months ago. The patient appears withdrawn, makes minimal eye contact, and gives brief responses to questions. Her oral hygiene has deteriorated significantly, with generalized heavy biofilm and multiple new carious lesions. When asked about changes at home or school, she mentions \"feeling sad all the time\" and \"not caring about anything anymore.\" The patient's mother confirms behavioral changes at home. What is the dental hygienist's MOST appropriate action according to the scope of practice outlined in the document?",
      options: [
        "Diagnose the patient with major depressive disorder and prescribe appropriate antidepressant medication protocols",
        "Provide immediate psychological counseling and establish weekly appointments to monitor mental health progress",
        "Identify the patient's needs, document findings, refer to primary healthcare provider, and provide mental health resources",
        "Implement intensive behavioral therapy techniques and develop a comprehensive treatment plan for depression"
      ],
      correct: "C"
    },
    {
      id: 27306,
      question: "CASE 7: During a community health presentation, a dental hygienist is discussing stress statistics from the COVID-19 pandemic era. She wants to accurately present data about how different generational groups reported stress levels during this time period. According to the Stress in America 2021 survey data presented in the document, which statement is MOST accurate?",
      options: [
        "Baby Boomers reported the highest overall stress levels and struggled most with daily decision-making during the pandemic",
        "Generation X experienced significantly more stress than all other groups, particularly related to employment and childcare",
        "Millennials reported experiencing more overall stress and struggling more with daily decision-making compared to other generations",
        "Generation Z showed the lowest stress levels due to better adaptive coping strategies and digital technology access"
      ],
      correct: "C"
    },
    {
      id: 27307,
      question: "CASE 8: A 52-year-old dental hygienist with 25 years of experience reports increasing chronic pain in her neck, shoulders, and hands. She mentions difficulty sleeping due to pain, takes NSAIDs daily, and worries about career longevity. She states she no longer enjoys hobbies like gardening and painting because she needs to \"recover from work\" before having energy for other activities. She expresses concern about potentially needing surgery and feels frustrated that physical limitations prevent her from providing optimal patient care. How do musculoskeletal disorders specifically contribute to professional burnout risk in dental hygienists?",
      options: [
        "They cause temporary discomfort that improves with proper ergonomics and regular stretching during work breaks",
        "They lead to chronic pain, potential surgery needs, shortened careers, and reduced capacity for enjoyable activities",
        "They primarily affect new graduates who haven't developed proper technique and experienced practitioners rarely experience them",
        "They result exclusively from poor posture and can be completely eliminated through strength training programs"
      ],
      correct: "B"
    },
    {
      id: 27308,
      question: "CASE 9: A dental office manager wants to implement policies to reduce burnout among the hygiene team. She is reviewing research on factors that influence professional burnout and job satisfaction in dental hygiene practice. According to studies cited in the document, which factor is identified as having MAJOR influence on professional burnout in dental hygienists?",
      options: [
        "The specific brand of dental equipment and instruments available in the practice setting",
        "The geographic location of the practice and regional cost of living variations",
        "The level of autonomy and ability to practice to the full extent of education and training",
        "The availability of free parking and convenient location relative to public transportation"
      ],
      correct: "C"
    },
    {
      id: 27309,
      question: "CASE 10: A dental hygiene educator is developing course content on mental health statistics. She wants to include accurate prevalence data about mental health conditions in the United States. According to the document, what is the approximate prevalence of major depressive disorder among US adults?",
      options: [
        "Approximately 4.4% of US adults experience major depressive disorder",
        "Approximately 8.4% of US adults experience major depressive disorder",
        "Approximately 12.4% of US adults experience major depressive disorder",
        "Approximately 16.4% of US adults experience major depressive disorder"
      ],
      correct: "B"
    },
    {
      id: 27310,
      question: "CASE 11: During patient education, a dental hygienist explains stress responses to help patients understand how anxiety affects their oral health. She describes different types of stress and their effects on the body. According to the document, what is the key difference between eustress and distress?",
      options: [
        "Eustress occurs only in professional settings while distress occurs only in personal life situations",
        "Eustress is brief lasting hours while distress persists for months requiring medical intervention",
        "Eustress is stress from positive events releasing endorphins while distress has deleterious impact releasing cortisol and adrenaline",
        "Eustress affects only young adults while distress affects only middle-aged and older populations"
      ],
      correct: "C"
    },
    {
      id: 27311,
      question: "CASE 12: A patient mentions he has been under significant stress at work and asks about how this might affect his oral health. He wants to understand the relationship between stress and oral conditions. Which statement BEST describes how chronic stress can manifest in oral health according to the document?",
      options: [
        "Chronic stress has no measurable effect on oral health and only affects systemic conditions",
        "Chronic stress primarily affects only tooth enamel causing generalized demineralization patterns",
        "Chronic stress can lead to neglect of oral hygiene, bruxism, xerostomia, and periodontal inflammation",
        "Chronic stress exclusively causes oral cancer with no effect on other oral tissues"
      ],
      correct: "C"
    },
    {
      id: 27312,
      question: "CASE 13: A dental practice wants to implement anxiety reduction techniques for fearful patients. The team reviews evidence-based approaches to help patients feel more comfortable during dental procedures. According to the document, which techniques are effective for reducing patient anxiety?",
      options: [
        "Using complex dental terminology and providing minimal explanations to save appointment time",
        "Deep breathing exercises, progressive muscle relaxation, guided imagery, and tell-show-do technique",
        "Scheduling appointments as quickly as possible and minimizing patient communication",
        "Avoiding any discussion of procedures and completing treatment without patient input"
      ],
      correct: "B"
    },
    {
      id: 27313,
      question: "CASE 14: A dental hygienist notices signs that may indicate a patient is experiencing mental health challenges. She wants to respond appropriately within her scope of practice. What role should the dental hygienist take regarding patient mental health according to the document?",
      options: [
        "Diagnose specific mental health disorders and prescribe appropriate psychiatric medications",
        "Provide ongoing psychotherapy and establish long-term mental health treatment plans",
        "Identify patient needs through assessment, provide resources and referrals, and document findings",
        "Ignore mental health concerns as these are outside the scope of dental hygiene practice"
      ],
      correct: "C"
    },
    {
      id: 27314,
      question: "CASE 15: A dental hygiene student is learning about the Diathesis-Stress Model (Vulnerability-Stress Model) in a mental health course. She wants to understand how this model applies to patient care. What does the Vulnerability-Stress Model explain according to the document?",
      options: [
        "Why all individuals respond identically to the same stressors and environmental conditions",
        "Why only genetic factors determine mental health outcomes regardless of environment",
        "Why individuals with different vulnerabilities respond differently to the same stressors",
        "Why stress has no impact on individuals who have genetic predispositions to resilience"
      ],
      correct: "C"
    },
    {
      id: 27315,
      question: "CASE 16: A dental office implements a wellness program for staff members. They want to educate the team about different categories of self-care. According to the document, what are the main categories of self-care that should be addressed?",
      options: [
        "Only physical self-care focusing exclusively on exercise and nutrition",
        "Physical, mental/emotional, social, and spiritual self-care",
        "Only mental/emotional self-care focusing on stress management techniques",
        "Only professional self-care focusing on continuing education and career advancement"
      ],
      correct: "B"
    },
    {
      id: 27316,
      question: "CASE 17: A dental hygienist working in a community health center sees patients from diverse backgrounds. She uses the Human Needs Conceptual Model to assess patients. According to the document, what types of issues can be identified using the Human Needs Model?",
      options: [
        "Only periodontal disease severity and caries risk assessment",
        "Fear of needles, fear of pain, financial stress, and anxiety related to dental care",
        "Only assessment of plaque and calculus levels on tooth surfaces",
        "Exclusively oral cancer screening and hard tissue examinations"
      ],
      correct: "B"
    },
    {
      id: 27317,
      question: "CASE 18: A patient asks about Maslow's Hierarchy of Needs after seeing a poster in the dental office waiting room. The dental hygienist wants to explain the concept and its relevance to dental care. According to the document, what represents the most basic level of Maslow's Hierarchy?",
      options: [
        "Self-actualization needs including personal growth and reaching full potential",
        "Esteem needs including self-respect, recognition, and achievement",
        "Physiological needs including food, water, shelter, and sleep",
        "Love and belonging needs including friendship, family, and intimacy"
      ],
      correct: "C"
    },
    {
      id: 27318,
      question: "CASE 19: A dental practice discusses the relationship between work stress and physical health during a staff meeting. They review research findings on stress and inflammation. According to the document, what is the relationship between work-related stress and inflammatory responses?",
      options: [
        "Lower work stress is associated with higher inflammatory markers and worse health outcomes",
        "Work stress has no measurable relationship with inflammatory responses in the body",
        "Higher work stress is associated with higher inflammatory responses that remain elevated",
        "Moderate work stress eliminates all inflammatory markers and improves immune function"
      ],
      correct: "C"
    },
    {
      id: 27319,
      question: "CASE 20: A dental hygienist experiences symptoms of professional burnout and discusses concerns with a colleague. She wants to understand whether burnout is classified as a mental health diagnosis. According to the document, how is professional burnout classified?",
      options: [
        "Burnout is an official psychiatric diagnosis listed in diagnostic manuals",
        "Burnout is classified as a specific anxiety disorder requiring medication",
        "Burnout is not an individual mental health diagnosis but rather an emotional response to chronic workplace stressors",
        "Burnout is a temporary mood disorder that resolves without any intervention"
      ],
      correct: "C"
    },
    {
      id: 27320,
      question: "CASE 21: A patient mentions she has been experiencing chronic stress and asks about potential long-term health effects. The dental hygienist provides education about stress-related health conditions. According to the document, which diseases are associated with chronic stress?",
      options: [
        "Only temporary conditions like common cold and minor infections",
        "Cardiovascular disease, insulin insensitivity, and cancer",
        "Only psychiatric conditions with no physical health manifestations",
        "Exclusively autoimmune disorders affecting only joint tissues"
      ],
      correct: "B"
    },
    {
      id: 27321,
      question: "CASE 22: A dental practice implements progressive muscle relaxation techniques to help anxious patients. The hygienist explains this technique during patient education. According to the document, what is progressive muscle relaxation?",
      options: [
        "A physical therapy technique for strengthening weak muscles",
        "A technique involving tensing and releasing different muscle groups to reduce tension",
        "A massage therapy approach requiring licensed massage therapist",
        "An exercise program designed to build muscle mass and strength"
      ],
      correct: "B"
    },
    {
      id: 27322,
      question: "CASE 23: A community health presentation focuses on mental health statistics globally. The presenter wants to provide accurate data about worldwide mental health prevalence. According to the document, how many people worldwide live with a mental health problem?",
      options: [
        "Approximately one out of every sixteen people worldwide",
        "Approximately one out of every eight people worldwide",
        "Approximately one out of every four people worldwide",
        "Approximately one out of every two people worldwide"
      ],
      correct: "B"
    },
    {
      id: 27323,
      question: "CASE 24: A dental hygiene program develops curriculum on documenting patient mental health observations. Students learn about proper documentation practices. According to the document, where should mental health-related observations and referrals be documented?",
      options: [
        "Mental health information should never be documented in any records",
        "Information should be posted on office bulletin boards for team awareness",
        "Patient behavior, findings, recommendations, and referrals should be recorded in the confidential healthcare record",
        "All mental health information should be shared publicly on social media"
      ],
      correct: "C"
    },
    {
      id: 27324,
      question: "CASE 25: A dental practice wants to create a more supportive environment for patients experiencing stress. The team discusses the importance of empathy and compassion. According to the document, why are empathy and compassion important in dental hygiene practice?",
      options: [
        "They are only important for marketing purposes and practice reputation",
        "They create a supportive environment that encourages patients to share concerns and seek help",
        "They are unnecessary as clinical skills are the only factor affecting patient outcomes",
        "They should be avoided as they create unhealthy emotional attachment to patients"
      ],
      correct: "B"
    },
    {
      id: 27325,
      question: "CASE 26: A patient asks about guided imagery after hearing it mentioned as an anxiety reduction technique. The dental hygienist explains this stress management approach. According to the document, what is guided imagery?",
      options: [
        "Looking at photographs or artwork in the treatment room",
        "Watching educational videos about dental procedures",
        "Visualizing calming and peaceful scenes to promote relaxation",
        "Reading magazines or books during dental treatment"
      ],
      correct: "C"
    },
    {
      id: 27326,
      question: "CASE 27: A dental office manager reviews policies about patient communication during treatment. She wants to ensure patients feel they have some control during procedures. According to the document, what technique helps patients feel more in control during dental treatment?",
      options: [
        "Completing all treatment without any breaks regardless of patient discomfort",
        "Using a predetermined signal that allows patients to communicate need for break",
        "Ignoring patient concerns and continuing treatment to maintain schedule",
        "Preventing any patient input to ensure efficient appointment management"
      ],
      correct: "B"
    },
    {
      id: 27327,
      question: "CASE 28: A dental hygienist attends a continuing education course on professional burnout. The presenter discusses factors that influence whether individuals experience burnout. According to the document, what relationship exists between autonomy and burnout?",
      options: [
        "Individuals experience more burnout when they have complete autonomy in practice",
        "Autonomy has no measurable relationship with burnout in healthcare professions",
        "Individuals experience less burnout when they perceive autonomy or clearly identify their professional roles",
        "Only dental assistants are affected by autonomy while hygienists are unaffected"
      ],
      correct: "C"
    },
    {
      id: 27328,
      question: "CASE 29: A staff wellness program focuses on nutrition as part of comprehensive self-care. Team members discuss strategies for maintaining healthy eating habits. According to healthy eating solutions in the document, which strategies support good nutrition?",
      options: [
        "Skipping all meals during workdays to maximize productivity",
        "Start prepping at least one meal per week, cutting out one high-sugar food, creating healthy snack packs",
        "Relying exclusively on fast food as the most convenient option",
        "Eliminating all carbohydrates and consuming only protein supplements"
      ],
      correct: "B"
    },
    {
      id: 27329,
      question: "CASE 30: A patient mentions she has been diagnosed with an anxiety disorder and takes medication. She asks whether this might affect her dental health. According to the document, what relationship exists between mental health and oral health?",
      options: [
        "Mental health and oral health are completely separate with no relationship",
        "Mental health conditions can affect oral health through medication side effects, hygiene neglect, and behaviors like bruxism",
        "Only severe psychiatric conditions requiring hospitalization affect oral health",
        "Mental health problems exclusively improve oral health through increased healthcare awareness"
      ],
      correct: "B"
    },
    {
      id: 27330,
      question: "CASE 31: A dental hygiene student learns about the tell-show-do technique for managing patient anxiety. She wants to understand this evidence-based approach. According to the document, what is the tell-show-do technique?",
      options: [
        "An outdated approach no longer used in modern dental practice",
        "A technique only appropriate for pediatric patients under age 12",
        "An approach involving explaining, demonstrating, then performing a procedure",
        "A behavior management technique requiring psychiatric medication"
      ],
      correct: "C"
    },
    {
      id: 27331,
      question: "CASE 32: A dental practice implements strategies to help staff maintain work-life balance. The office manager discusses the importance of self-care for reducing burnout. According to the document, why is self-care important for dental hygienists?",
      options: [
        "Self-care is a selfish luxury that takes time away from patient care",
        "Self-care reduces burnout, maintains health, and improves quality of patient care",
        "Self-care is only necessary for hygienists with pre-existing mental health conditions",
        "Self-care has no measurable impact on professional performance or well-being"
      ],
      correct: "B"
    },
    {
      id: 27332,
      question: "CASE 33: A patient experiencing stress asks about the fight or flight response she has heard mentioned. The dental hygienist provides education about this physiological response. According to the document, what is the fight or flight response?",
      options: [
        "A learned behavior that must be taught through specific training programs",
        "A self-limiting adaptation to threats mediated by the sympathetic branch of the autonomic nervous system",
        "An abnormal reaction indicating severe psychiatric disorder requiring medication",
        "A permanent state of hyperarousal that persists indefinitely once activated"
      ],
      correct: "B"
    },
    {
      id: 27333,
      question: "CASE 34: A dental office creates a referral network for patients needing mental health support. The team discusses appropriate professionals for referrals. According to the document, which professionals are examples of licensed mental health providers?",
      options: [
        "Only dentists and dental hygienists with additional training",
        "Psychologists, psychiatrists, licensed counselors, and clinical social workers",
        "Only medical doctors and nurse practitioners",
        "Exclusively pharmacists and physical therapists"
      ],
      correct: "B"
    },
    {
      id: 27334,
      question: "CASE 35: A dental hygienist notices a patient showing multiple signs of stress during appointments. She considers using environmental modifications to help reduce anxiety. According to the document, what environmental modifications can help reduce patient anxiety?",
      options: [
        "Using bright fluorescent lighting and playing loud music",
        "Maintaining very cold temperatures and harsh clinical atmosphere",
        "Comfortable temperature, calming music, and pleasant scents in the environment",
        "Eliminating all sensory input with complete silence and darkness"
      ],
      correct: "C"
    },
    {
      id: 27335,
      question: "CASE 36: A community health presentation addresses the mental health impact of the COVID-19 pandemic. The presenter wants to share accurate statistics. According to the document, approximately what percentage of respondents felt stressed about the COVID-19 pandemic?",
      options: [
        "Approximately one-quarter of respondents felt stressed about COVID-19",
        "Approximately one-third of respondents felt stressed about COVID-19",
        "Approximately one-half of respondents felt stressed about COVID-19",
        "Approximately two-thirds of respondents felt stressed about COVID-19"
      ],
      correct: "B"
    },
    {
      id: 27336,
      question: "CASE 37: A dental practice implements communication strategies to reduce patient anxiety. The team reviews evidence-based approaches for patient interaction. According to the document, which communication strategies help reduce patient anxiety?",
      options: [
        "Using complex medical jargon and avoiding explanations to save time",
        "Providing clear explanations, active listening, and encouraging questions",
        "Dismissing patient concerns and minimizing two-way communication",
        "Speaking rapidly without pauses and avoiding eye contact with patients"
      ],
      correct: "B"
    },
    {
      id: 27337,
      question: "CASE 38: A patient asks why she should seek professional help for stress rather than just managing it herself. The dental hygienist provides education about mental health care. According to the document, what can credentialed mental health professionals provide?",
      options: [
        "Only symptom checklists with no treatment recommendations",
        "Evidence-based treatment approaches tailored to individual needs",
        "Only prescription medications with no other interventions",
        "Generic advice identical to what can be found online"
      ],
      correct: "B"
    },
    {
      id: 27338,
      question: "CASE 39: A dental hygiene program develops content about the scope of practice regarding mental health. Students learn about appropriate actions within their role. According to the document, what should dental hygienists do when they identify patient mental health needs?",
      options: [
        "Prescribe psychiatric medications based on observed symptoms",
        "Provide ongoing psychotherapy during regular hygiene appointments",
        "Identify needs, provide resources and referrals to appropriate professionals, and document findings",
        "Diagnose mental health disorders based on behavioral observations"
      ],
      correct: "C"
    },
    {
      id: 27339,
      question: "CASE 40: A staff meeting focuses on recognizing symptoms of chronic stress. The team discusses physiological signs that may indicate excessive stress. According to the document, what physical symptoms may result from chronic stress?",
      options: [
        "Only improved energy levels and enhanced physical performance",
        "Negative effects on immune system, elevated heart rate, and elevated blood pressure",
        "Exclusively dental symptoms with no systemic manifestations",
        "Only temporary symptoms that never require medical attention"
      ],
      correct: "B"
    },
    {
      id: 27340,
      question: "CASE 41: A dental hygienist experiences musculoskeletal pain from years of clinical practice. She discusses this with colleagues who share similar concerns. According to the document, what typically causes musculoskeletal disorders in dental hygienists?",
      options: [
        "Excessive breaks and too much variety in daily tasks",
        "Repetitive movements, sustained static positions, and use of vibrating equipment",
        "Perfect ergonomic setup and proper positioning techniques",
        "Working fewer than 20 hours per week in clinical practice"
      ],
      correct: "B"
    },
    {
      id: 27341,
      question: "CASE 42: A patient asks about statistics on anxiety disorders after mentioning his own diagnosis. The dental hygienist shares general prevalence information. According to the document, what percentage of the US population experiences an anxiety disorder at some point in their lifetime?",
      options: [
        "Approximately 21% of US population experiences anxiety disorder lifetime",
        "Approximately 31% of US population experiences anxiety disorder lifetime",
        "Approximately 41% of US population experiences anxiety disorder lifetime",
        "Approximately 51% of US population experiences anxiety disorder lifetime"
      ],
      correct: "B"
    },
    {
      id: 27342,
      question: "CASE 43: A dental practice implements proactive strategies to reduce staff burnout before it becomes severe. The team discusses early intervention. According to the document, what approach should dental hygienists take regarding burnout risk?",
      options: [
        "Ignore early warning symptoms and continue working without changes",
        "Wait until complete breakdown occurs before seeking help",
        "Address the situation early and be proactive in implementing changes",
        "Deny problems exist and avoid discussing stress with others"
      ],
      correct: "C"
    },
    {
      id: 27343,
      question: "CASE 44: A dental office creates patient education materials about stress management. They want to include information about different types of stress. According to the document, what characterizes acute stress?",
      options: [
        "Acute stress is a long-term chronic condition lasting many years",
        "Acute stress is a permanent state that never resolves",
        "Acute stress is typically a one-time occurrence or short-term in nature",
        "Acute stress exclusively occurs in individuals with anxiety disorders"
      ],
      correct: "C"
    },
    {
      id: 27344,
      question: "CASE 45: A community health program addresses mental health stigma. The presenter discusses historical attitudes and current recommendations. According to the document, what statement about mental health stigma is accurate?",
      options: [
        "Mental health has never been stigmatized in society",
        "Mental health has historically had stigma, but people should seek help for unmanageable stress",
        "Mental health stigma means individuals should always manage problems alone",
        "Seeking professional help for mental health problems shows weakness"
      ],
      correct: "B"
    },
    {
      id: 27345,
      question: "CASE 46: A patient mentions she has read information online and believes she has several mental health conditions. The dental hygienist discusses the importance of professional evaluation. According to the document, what should individuals avoid doing with online mental health information?",
      options: [
        "Reading any information from reputable mental health organizations",
        "Self-diagnosing based on information found online without professional evaluation",
        "Learning about mental health conditions and treatment options",
        "Finding resources and support groups for mental health concerns"
      ],
      correct: "B"
    },
    {
      id: 27346,
      question: "CASE 47: A dental hygienist reflects on changes in her feelings about work over time. She remembers her initial career motivation compared to current experience. According to the document, how do healthcare careers typically begin?",
      options: [
        "Healthcare workers typically begin careers feeling cynical and burned out",
        "Individuals typically start careers with enthusiasm, excitement, and motivation to make a difference",
        "Most healthcare workers choose careers randomly without genuine interest",
        "Professional burnout is present from the first day and persists throughout careers"
      ],
      correct: "B"
    },
    {
      id: 27347,
      question: "CASE 48: A dental practice reviews research on factors that make staff feel valued at work. They want to implement policies that improve job satisfaction. According to the document, what factors heavily influence whether dental hygienists feel valued?",
      options: [
        "Only professional title and credentials displayed",
        "Pay rates, adequate appointment times, and scheduled breaks",
        "Only the geographic location of the practice",
        "Exclusively the availability of continuing education courses"
      ],
      correct: "B"
    },
    {
      id: 27348,
      question: "CASE 49: A patient describes feeling overwhelmed, having difficulty concentrating, experiencing mood changes with irritability, and struggling to make decisions. She asks if these could be stress-related. According to the document, how should these symptoms be characterized?",
      options: [
        "These symptoms are exclusively indicative of severe psychiatric disorders unrelated to stress",
        "These symptoms represent psychological symptoms that may result from stress and stressors",
        "Only physical symptoms indicate stress; psychological symptoms are unrelated",
        "These symptoms never occur with stress and always indicate medical emergencies"
      ],
      correct: "B"
    },
    {
      id: 27349,
      question: "CASE 50: A dental hygiene educator discusses the importance of stress management education in the curriculum. She explains the rationale to students. According to the document, why is it important for dental hygienists to learn about stress management and self-care?",
      options: [
        "Stress management skills are unnecessary as dental hygienists never experience work stress",
        "These skills help reduce professional burnout, improve well-being, and improve quality of patient care",
        "Only dental hygienists with pre-existing mental health conditions need this education",
        "Stress management education is exclusively for practice owners and managers"
      ],
      correct: "B"
    },
    {
      id: 27350,
      question: "CASE 51: A patient with depression mentions her oral hygiene has deteriorated significantly. She states basic tasks like brushing feel overwhelming when experiencing symptoms. According to the document, what relationship does this illustrate?",
      options: [
        "There is no relationship between depression and oral hygiene practices",
        "Oral health can suffer when depression symptoms lead to neglect of daily activities",
        "Depression improves oral hygiene because patients have more time available",
        "Only severe psychiatric conditions requiring hospitalization affect oral hygiene"
      ],
      correct: "B"
    },
    {
      id: 27351,
      question: "CASE 52: A staff wellness committee reviews research on the health benefits of social connection. They want to encourage team bonding activities. According to the document, what are benefits of maintaining social connections?",
      options: [
        "Social connections waste time that should be devoted to work productivity",
        "Creating opportunities to connect counteracts loneliness; lack of connection is associated with health risks equivalent to smoking 15 cigarettes daily",
        "Social connections increase inflammatory markers and worsen health",
        "Only extroverted individuals benefit from social connections"
      ],
      correct: "B"
    },
    {
      id: 27352,
      question: "CASE 53: A dental practice implements a policy for selecting mental health professionals for patient referrals. They want to ensure appropriate referral sources. According to the document, what is important when selecting a mental health professional for referral?",
      options: [
        "Selecting the provider with lowest cost regardless of credentials",
        "Choosing the provider with the closest location regardless of qualifications",
        "Ensuring the person is licensed and uses evidence-based practice approaches",
        "Selecting the provider with fastest available appointment regardless of expertise"
      ],
      correct: "C"
    },
    {
      id: 27353,
      question: "CASE 54: A dental hygienist discusses different treatment options for mental health conditions during a patient conversation. She provides general education. According to the document, what treatments may be recommended by mental health professionals?",
      options: [
        "Only medication with no other intervention options",
        "Therapy, medication, mindfulness practices, and support groups",
        "Only group therapy with no individual treatment",
        "Exclusively hospitalization for all mental health conditions"
      ],
      correct: "B"
    },
    {
      id: 27354,
      question: "CASE 55: A patient asks about the relationship between mental health conditions and dental treatment. The dental hygienist explains how these factors interact. According to the document, how can mental health conditions affect dental treatment?",
      options: [
        "Mental health conditions have no effect on dental treatment outcomes",
        "Only positive effects occur when patients have mental health conditions",
        "Mental health conditions can affect dental treatment and should be considered in care planning",
        "Mental health should never be discussed in dental settings"
      ],
      correct: "C"
    },
    {
      id: 27355,
      question: "CASE 56: A dental office trains staff on recognizing signs that patients may need mental health support. They discuss observable behavioral changes. According to the document, what should dental hygienists observe that might indicate mental health concerns?",
      options: [
        "Only the condition of teeth and gingival tissues",
        "Behavioral changes, signs of distress, and changes in oral health status",
        "Only the presence of dental caries and periodontal disease",
        "Exclusively radiographic findings and clinical measurements"
      ],
      correct: "B"
    },
    {
      id: 27356,
      question: "CASE 57: A community health presentation addresses how stress affects physical health over time. The presenter explains chronic stress effects. According to the document, what can stress contribute to behaviorally that affects health?",
      options: [
        "Improved healthy habits and better daily routines",
        "Changes in eating patterns and physical activity levels",
        "Enhanced self-care and better health behaviors",
        "No behavioral changes occur with stress"
      ],
      correct: "B"
    },
    {
      id: 27357,
      question: "CASE 58: A patient asks whether seeking professional help for stress management is necessary or if self-help is sufficient. The dental hygienist discusses professional support. According to the document, when should individuals seek professional help for mental health concerns?",
      options: [
        "Only after life feels completely uncontrollable and breakdown occurs",
        "Never, as everyone should handle stress independently without help",
        "When experiencing unmanageable stress, without waiting for life to feel uncontrollable",
        "Only if family members or employers require it"
      ],
      correct: "C"
    },
    {
      id: 27358,
      question: "CASE 59: A dental hygiene student learns about episodic acute stress during a mental health module. She wants to understand this stress classification. According to the document, what characterizes episodic acute stress?",
      options: [
        "A single stressor experience occurring one time only",
        "Complete absence of any stress or stressors",
        "Repeated acute stress occurring in demanding jobs or circumstances",
        "Long-term chronic stress lasting many years"
      ],
      correct: "C"
    },
    {
      id: 27359,
      question: "CASE 60: A dental practice discusses the relationship between burnout and patient care quality during a team meeting. They review research findings. According to the document, how does burnout affect dental hygienists' work performance?",
      options: [
        "Burnout improves performance by increasing focus",
        "Burned out providers may not perform to the best of their ability",
        "Burnout has no measurable effect on clinical performance",
        "Burnout exclusively affects only non-clinical administrative tasks"
      ],
      correct: "B"
    },
    {
      id: 27360,
      question: "CASE 61: A patient mentions she has heard about the relationship between stress and chronic disease. She asks for more information. According to the document, how does the body respond when stressors are repeated over time?",
      options: [
        "Inflammatory markers decrease and health improves",
        "Inflammatory markers stay elevated which can contribute to disease",
        "The body adapts completely and stress has no further effects",
        "Only psychological effects occur with no physical manifestations"
      ],
      correct: "B"
    },
    {
      id: 27361,
      question: "CASE 62: A dental office implements wellness initiatives focused on multiple aspects of health. They discuss comprehensive self-care categories. According to the document, what does physical self-care include?",
      options: [
        "Only cardiovascular exercise with no other components",
        "Exercise, proper nutrition, adequate sleep, and regular healthcare checkups",
        "Only dietary changes with no other interventions",
        "Exclusively sleep hygiene with no other factors"
      ],
      correct: "B"
    },
    {
      id: 27361,
      question: "CASE 63: A patient asks about demographic patterns in major depressive disorder after learning about his diagnosis. The dental hygienist shares general statistics. According to the document, which gender has higher prevalence of major depressive disorder?",
      options: [
        "Males have significantly higher prevalence rates",
        "Females have higher prevalence of major depressive disorder",
        "Prevalence is exactly equal across all gender groups",
        "Only non-binary individuals are affected by depression"
      ],
      correct: "B"
    },
    {
      id: 27363,
      question: "CASE 64: A dental hygiene program discusses age-related patterns in mental health conditions. Students learn about depression prevalence across age groups. According to the document, which age group has the highest prevalence of major depressive disorder?",
      options: [
        "Ages 12 to 17 have the highest prevalence",
        "Ages 18 to 25 have the highest prevalence",
        "Ages 26 to 40 have the highest prevalence",
        "Ages 41 to 60 have the highest prevalence"
      ],
      correct: "B"
    },
    {
      id: 27364,
      question: "CASE 64: A community wellness program addresses the importance of exercise for stress management. Participants ask about specific benefits. According to the document, how does exercise affect stress levels?",
      options: [
        "Exercise significantly increases stress levels",
        "Exercise reduces stress levels and improves well-being",
        "Exercise has no measurable effect on stress",
        "Exercise worsens mood and anxiety"
      ],
      correct: "B"
    },
    {
      id: 27365,
      question: "CASE 66: A dental practice reviews protocols for addressing patient anxiety about dental procedures. They discuss creating signals for patient control. According to the document, what communication technique helps patients feel they have control during treatment?",
      options: [
        "Completing treatment without breaks to maintain efficiency",
        "Establishing a signal that allows patients to indicate need for pause",
        "Ignoring patient distress and continuing procedures",
        "Preventing any patient communication during treatment"
      ],
      correct: "B"
    },
    {
      id: 27366,
      question: "CASE 67: A patient asks about the increase in mental health problems over time. The dental hygienist shares statistics from the document. According to the document, what percentage increase in sadness or hopelessness occurred since 2009?",
      options: [
        "Approximately 20% increase in sadness/hopelessness",
        "Approximately 40% increase in sadness/hopelessness",
        "Approximately 60% increase in sadness/hopelessness",
        "Approximately 80% increase in sadness/hopelessness"
      ],
      correct: "B"
    },
    {
      id: 27367,
      question: "CASE 68: A dental hygienist discusses the holistic approach to patient care with a new graduate. She explains the importance of considering multiple factors. According to the document, what approach provides comprehensive patient care?",
      options: [
        "Focusing exclusively on clinical symptoms and procedures",
        "Considering only disease processes without other factors",
        "Using a holistic whole-person approach considering physical and mental health",
        "Addressing only payment methods and insurance coverage"
      ],
      correct: "C"
    },
    {
      id: 27368,
      question: "CASE 69: A staff meeting discusses factors that contribute to frequent absences from work. The team reviews research on stress-related health issues. According to the document, what symptoms can contribute to frequent leaves from work?",
      options: [
        "Excellent physical and mental health with high motivation",
        "Mental fatigue, impatience, and frequent headaches from chronic stress",
        "Great job satisfaction and positive workplace relationships",
        "Enhanced energy levels and improved focus"
      ],
      correct: "B"
    },
    {
      id: 27369,
      question: "CASE 70: A dental practice implements protocols to ensure patient privacy regarding mental health information. Staff reviews confidentiality requirements. According to the document, how must patient privacy be maintained regarding mental health information?",
      options: [
        "Mental health information should be shared publicly for awareness",
        "Patient privacy and confidentiality must be maintained for all health information",
        "Mental health information can be posted on social media",
        "All mental health observations should be discussed openly in waiting room"
      ],
      correct: "B"
    },
    {
      id: 27370,
      question: "CASE 71: A patient asks about statistics on mental health in Canada. The dental hygienist shares general prevalence information. According to the document, what percentage of Canadians experience mental health problems in a given year?",
      options: [
        "One in ten Canadians experience mental health problems yearly",
        "One in five Canadians experience mental health problems yearly",
        "One in three Canadians experience mental health problems yearly",
        "One in two Canadians experience mental health problems yearly"
      ],
      correct: "B"
    },
    {
      id: 27371,
      question: "CASE 72: A dental hygiene educator develops curriculum on recognizing when to refer patients for mental health support. Students learn about professional boundaries. According to the document, what should dental hygienists recognize regarding patient mental health?",
      options: [
        "Dental hygienists should provide long-term mental health therapy",
        "When patients need referral to other mental health professionals",
        "Dental hygienists should prescribe psychiatric medications",
        "Mental health concerns should never be acknowledged"
      ],
      correct: "B"
    },
    {
      id: 27372,
      question: "CASE 73: A patient mentions feeling cynical about work and emotionally detached from his job. He asks if this is normal stress. According to the document, what feelings correlate with professional burnout?",
      options: [
        "Enhanced connection to work and increased enthusiasm",
        "Better engagement with work and improved motivation",
        "Detachment from work and feelings of cynicism",
        "Greater satisfaction and improved performance"
      ],
      correct: "C"
    },
    {
      id: 27373,
      question: "CASE 74: A dental practice reviews the impact of appointment scheduling on staff stress. They discuss research on work conditions. According to the document, what can affect a dental hygienist's ability to address patient anxiety?",
      options: [
        "Excessive free time and too many available resources",
        "Time constraints and inadequate appointment scheduling",
        "Abundant support staff and unlimited resources",
        "Too few patients and excessive breaks"
      ],
      correct: "B"
    },
    {
      id: 27374,
      question: "CASE 75: A community health presentation addresses the COVID-19 pandemic's impact on dental professionals. The presenter shares research findings. According to the document, how did dental professionals fare regarding burnout during the pandemic?",
      options: [
        "Dentists and hygienists experienced lower burnout than other professions",
        "Dentists and dental hygienists experienced higher rates of burnout than many other professions",
        "Dental professionals were completely unaffected by pandemic stress",
        "Only dental assistants experienced burnout, not hygienists"
      ],
      correct: "B"
    },
    {
      id: 27375,
      question: "CASE 76: A patient asks what happens when dental hygienists feel unable to adequately address patient anxiety due to time constraints. According to the document, what can this inability lead to?",
      options: [
        "Improved job satisfaction and better outcomes",
        "Enhanced performance and career advancement",
        "Feelings of personal failure, burnout, and job dissatisfaction",
        "Better patient relationships and increased motivation"
      ],
      correct: "C"
    },
    {
      id: 27376,
      question: "CASE 77: A dental office implements strategies to help patients who experience musculoskeletal pain. They discuss the impact on daily life. According to the document, how can chronic pain from musculoskeletal disorders affect dental hygienists?",
      options: [
        "Chronic pain only affects work with no impact on personal life",
        "Pain reduces capacity for enjoyable activities outside work during recovery time",
        "Musculoskeletal disorders exclusively improve with time and never require intervention",
        "Pain affects only new graduates and never experienced practitioners"
      ],
      correct: "B"
    },
    {
      id: 27377,
      question: "CASE 78: A dental practice discusses the relationship between job satisfaction, burnout, and turnover. They review research on these interconnected factors. According to the document, what influences each other regarding professional burnout?",
      options: [
        "Only job satisfaction influences outcomes independently",
        "Job satisfaction, burnout, and intention to leave profession influence each other",
        "Only burnout affects outcomes with no other factors",
        "These factors operate completely independently"
      ],
      correct: "B"
    },
    {
      id: 27378,
      question: "CASE 79: A community wellness program addresses the importance of proactive stress management. Participants discuss best practices. According to the document, what is one of the best ways to protect against chronic stress?",
      options: [
        "Relying exclusively on medication with no lifestyle changes",
        "Making healthy lifestyle choices including exercise, nutrition, and social connection",
        "Complete avoidance of all potential stressors through isolation",
        "Waiting until crisis occurs before taking any action"
      ],
      correct: "B"
    },
    {
      id: 27379,
      question: "CASE 80: A dental hygiene student learns about the scope of practice for addressing mental health. She wants to understand her future role. According to the document, what defines mental health that dental hygienists should understand?",
      options: [
        "Only the absence of diagnosed psychiatric disorders",
        "Emotional, psychological, and social well-being affecting thoughts, feelings, and actions",
        "Only physical health with no psychological components",
        "Exclusively severe mental illnesses requiring hospitalization"
      ],
      correct: "B"
    },
    {
      id: 27380,
      question: "CASE 81: A patient asks about the prevalence of mental health illness in the United States. The dental hygienist shares general statistics. According to the document, what percentage of US adults reported mental health illness in 2019?",
      options: [
        "Approximately 10% of US adults reported mental illness",
        "Approximately 20% of US adults reported mental illness",
        "Approximately 30% of US adults reported mental illness",
        "Approximately 40% of US adults reported mental illness"
      ],
      correct: "B"
    },
    {
      id: 27381,
      question: "CASE 82: A dental practice trains staff on using the Human Needs Conceptual Model for patient assessment. They discuss what can be identified using this framework. According to the document, what types of patient issues can the Human Needs Model help identify?",
      options: [
        "Blood pressure readings, heart rate measurements, and laboratory test results exclusively",
        "Fear of needles, fear of pain, and financial stress are examples of issues identified using the model",
        "Only severe psychiatric disorders can be identified using the human needs conceptual model",
        "The human needs model cannot identify any stress or fear-related issues in patients"
      ],
      correct: "B"
    },
    {
      id: 27383,
      question: "CASE 83: A dental practice implements meal preparation strategies to help staff maintain healthy nutrition during busy workweeks. Team members share ideas for making healthy eating more convenient and sustainable. According to healthy eating solutions recommended in the document, which strategies can help maintain good nutrition?",
      options: [
        "Skip all meals during the workday to maximize productivity and patient appointment availability",
        "Start prepping at least one meal during the week, cut out one high-sugar food, create healthy snack packs",
        "Rely exclusively on fast food and vending machines as these are the most convenient options",
        "Eliminate all carbohydrates from the diet and consume only protein supplements"
      ],
      correct: "B"
    },
    {
      id: 27384,
      question: "CASE 84: A patient asks about \"flight or fight\" response terminology. She wonders whether this is the same thing as stress or if these are different concepts. She wants to understand the body's natural response to perceived threats. According to the document's description, what is the fight or flight response?",
      options: [
        "A learned behavior that must be taught through specific training programs and practice",
        "A self-limiting adaptation to threats mediated by the sympathetic branch of the autonomic nervous system",
        "An abnormal reaction indicating severe psychiatric disorder requiring immediate medication",
        "A permanent state of hyperarousal that persists indefinitely once activated"
      ],
      correct: "B"
    },
    {
      id: 27385,
      question: "CASE 85: A dental hygiene program develops a wellness curriculum for students. The curriculum includes education about recognizing signs of chronic stress, implementing self-care strategies, and knowing when to seek professional help for mental health concerns. According to the document, why is it important for dental hygienists to learn about stress management and self-care?",
      options: [
        "Stress management skills are unnecessary as dental hygienists never experience workplace stress",
        "These skills help reduce professional burnout, improve well-being, and improve overall quality of patient care",
        "Only dental hygienists with pre-existing mental health conditions need stress management education",
        "Stress management education is exclusively for practice owners and managers, not clinical staff"
      ],
      correct: "B"
    },
    {
      id: 27386,
      question: "CASE 86: A patient with depression mentions that her oral hygiene has deteriorated significantly. She states that basic daily activities like brushing teeth \"feel like too much effort\" when she's experiencing depressive symptoms. She appears embarrassed about the condition of her mouth. This scenario illustrates which relationship discussed in the document between mental health and oral health?",
      options: [
        "There is no relationship between depression and oral hygiene practices; these are separate issues",
        "Oral health can suffer when depression symptoms lead to neglect of daily activities such as proper oral hygiene",
        "Depression improves oral hygiene compliance because patients have more time for self-care",
        "Only severe psychiatric conditions requiring hospitalization affect oral hygiene behaviors"
      ],
      correct: "B"
    },
    {
      id: 27387,
      question: "CASE 87: A staff wellness committee discusses ways to improve social connection among team members to reduce feelings of isolation and burnout. They review research on the importance of meaningful relationships and social support. According to staying connected recommendations in the document, what are benefits of maintaining social connections?",
      options: [
        "Social connections waste time and energy that should be devoted to work productivity exclusively",
        "Creating opportunities to connect counteracts loneliness; lack of connection is associated with health risks equivalent to smoking 15 cigarettes daily",
        "Social connections increase inflammatory markers and worsen both physical and mental health",
        "Only extroverted individuals benefit from social connections; introverts should avoid all social interaction"
      ],
      correct: "B"
    },
    {
      id: 27388,
      question: "CASE 88: A patient mentions experiencing symptoms including feeling anxious, feeling overwhelmed, difficulties concentrating, constant rumination, changes in mood with irritability, and inability to make decisions. She asks whether these could be related to stress she's experiencing at work. According to the psychological symptoms of stress listed in the document, which statement is MOST accurate?",
      options: [
        "These symptoms are exclusively indicative of severe psychiatric disorders unrelated to stress",
        "These symptoms represent psychological symptoms that may result from stress and stressors",
        "Only physical symptoms indicate stress; psychological symptoms are unrelated to stressors",
        "These symptoms never occur with stress and always indicate other medical conditions"
      ],
      correct: "B"
    },
    {
      id: 27389,
      question: "CASE 89: A practice implements a protocol for documenting patient mental health observations and referrals. The office manager reviews requirements regarding what information must be documented and patient privacy protections. According to legal and ethical considerations in the document, how should mental health information be handled?",
      options: [
        "Mental health information should be shared publicly on social media to encourage community awareness",
        "Patient behavior, findings, recommendations, and referrals should be recorded as part of the confidential healthcare record",
        "Mental health observations should never be documented anywhere under any circumstances",
        "All mental health information must be reported to employers and insurance companies immediately"
      ],
      correct: "B"
    },
    {
      id: 27390,
      question: "CASE 90: A dental hygienist reflects on her early career enthusiasm compared to her current feelings about work. She initially chose dental hygiene because she wanted to prevent disease and educate patients about oral health. She loved working as part of a healthcare team and felt passionate about helping people. Now she feels cynical about her work and detached from patients. According to the document's discussion of professional burnout, what typically characterizes the beginning of a healthcare career?",
      options: [
        "Healthcare workers typically start careers feeling cynical, burned out, and detached from patients",
        "Individuals typically start careers with enthusiasm, excitement, and motivation to perform skills well and make a difference",
        "Most healthcare workers choose careers randomly without passion or genuine interest in helping",
        "Professional burnout is present from graduation and persists unchanged throughout entire careers"
      ],
      correct: "B"
    }
  ]
};
